/**
 * Deep Link Library API client (FEAT-DEEPLINK-001).
 *
 * Mirrors the writer-backend /deep-link/* routes. Auth = x-access-token +
 * x-api-key via getApiHeaders() (verifyToken reads x-access-token and pins the
 * tenant server-side). CSV routes post multipart FormData (field "file").
 */
import API from '../helpers/axiosInstance';
import { getApiHeaders } from '../utils/DefaultFunction';

const BASE = () => `${process.env.REACT_APP_API_URL}/deep-link`;
const cfg = () => ({ headers: getApiHeaders() });

export const deepLinksApi = {
  list: (params = {}) => API.get(`${BASE()}/list`, { ...cfg(), params }),
  getById: (id) => API.get(`${BASE()}/get-by-id`, { ...cfg(), params: { id } }),
  create: (body) => API.post(`${BASE()}/create`, body, cfg()),
  update: (body) => API.post(`${BASE()}/update`, body, cfg()),
  setStatus: (id, status_id) => API.post(`${BASE()}/status`, { id, status_id }, cfg()),
  remove: (id) => API.post(`${BASE()}/delete`, { id }, cfg()),

  importPreview: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return API.post(`${BASE()}/import/preview`, fd, { headers: getApiHeaders() });
  },
  importApply: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return API.post(`${BASE()}/import`, fd, { headers: getApiHeaders() });
  },

  // GET endpoints are auth-gated, so fetch as a blob (an <a href> wouldn't carry
  // the x-access-token header) and let the caller trigger the download.
  exportCsv: () => API.get(`${BASE()}/export`, { ...cfg(), responseType: 'blob' }),
  sampleCsv: () => API.get(`${BASE()}/sample-csv`, { ...cfg(), responseType: 'blob' }),
};

/** Trigger a browser download for a fetched Blob. */
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export default deepLinksApi;
